<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('meassurement units')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      :page_length="50"
      resource_url="/product/meassurement-unit/datatables"
    ></generic-table>
  </div>

  <unit-modal ref="unit_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  api_host,
} from "@/utils";
import UnitModal from "./unit_modal/Index.vue";

export default {
  name: "ProductMeassurementUnitDatatable",
  components: { GenericTable, UnitModal },
  data() {
    let v = this;
    return {
      api_host,
      extra_buttons: [
        {
          text: v.$t("add"),
          icon: "fa fa-plus",
          class: "is-secondary is-rounded",
          click: this.create,
        },
      ],
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name || "";
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.unit_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete meassurement unit?"),
                    v,
                    () => {
                      del("/product/meassurement-unit", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.unit_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
